<template>
  <div
    class="activity-box"
    :class="isPe ? 'pe' : ''"
  >
    <div
      class="navbar"
      v-if="isPe"
    >
      <div
        class="title"
        style="text-align:center"
      >
        <img :src="logo" />
      </div>
      <div class="open-menu-icon">
        <Icon
          type="ios-arrow-back"
          @click="toHome()"
        />
      </div>
    </div>
    <div class="page1">
      <img
        :src="isPe ? peBanner : banner"
        class="banner"
      />
      <div class="main-msg">
        庫米科技（大連）有限公司（以下、当社といいます）が主催する「Twitterリツイートキャンペーン」（以下、当該キャンペーンといいます）にご応募いただく前に、本規約をよくお読みいただき同意の上ご応募ください。<br />
        当該キャンペーンにご応募された場合、本規約にご同意いただいたものとみなします。<br />
        万一、本規約にご同意いただけない場合には、本キャンペーンへの応募はご遠慮ください。
      </div>
      <div class="link-url">
        <label>リンク：</label>
        <a href="https://www.twitter.com/nanacokume">https://www.twitter.com/nanacokume</a>
      </div>
      <div class="msg-list-box">
        <div class="msg-list-title">
          1. 応募期間について
        </div>
        <div class="msg-list">
          <div class="msg">
            キャンペーン期間：<b>2020年11月6日（金） 10:00 ～ 2020年11月11日（水） 23:59</b>
          </div>
          <div class="msg">
            やむを得ない事情により、応募期間は予告なく変更となることがあります。
          </div>
        </div>
      </div>
      <div class="msg-list-box">
        <div class="msg-list-title">
          2. プレゼントについて
        </div>
        <div class="msg-list">
          <div class="msg">
            期間中に応募された応募者のうち、抽選で最大合計50名様にNanacoアプリで使用できる「クーポン券30元分」をプレゼントいたします。
          </div>
          <div class="msg">
            やむを得ない事情により、プレゼントは予告なく変更となることがあります。
          </div>
        </div>
      </div>
      <div class="msg-list-box">
        <div class="msg-list-title">
          3. 応募方法について
        </div>
        <div class="msg-list">
          <div
            class="msg"
            type="li"
          >
            ・Twitter上で、指定の投稿をリツイートしてください。<br />
            ・アカウントを非公開設定にしている場合はご応募対象外です。 <br />
            ・応募の対象となるのはリツイートのみで、引用ツイートの場合ご応募対象外です。<br />
            ・やむを得ない事情により、応募方法は予告なく変更となることがあります。<br />
            ・Twitterシステムのエラー・システム障害等その他やむを得ない事情により、リプライが送信されない、フォローやリツイートができない場合があります。<br />
            ・Twitterシステムのエラー・システム障害等その他やむを得ない事情により、予告なくキャンペーンを途中で中止、終了する場合があります。
          </div>
        </div>
      </div>
      <div class="msg-list-box">
        <div class="msg-list-title">
          4. 応募資格について
        </div>
        <div class="msg-list">
          <div class="msg">
            ・Twitter上で、指定の投稿をリツイートすることで応募の意思確認とさせていただきます。<br />
            ・本キャンペーン実施期間中は、TwitterのIDを変更しないようお願いいたします。<br />
            ・複数のTwitterアカウントで応募された場合、当選資格を無効とさせていただきます。<br />
            ・当社関係者及び当キャンペーン関係者の応募はできません。<br />
            ・クーポン券は、中国国内においてのみご使用が可能となります。よって、ご応募は中国にお住まいの方、もしくは近く中国へ渡航予定の方に限らせていただきます。<br />
            ・未成年の方は、親権者の方が応募規約に同意いただいた上でキャンペーンの応募をお願いいたします。
          </div>
        </div>
      </div>
      <div class="msg-list-box">
        <div class="msg-list-title">
          5.当選について
        </div>
        <div class="msg-list">
          <div class="msg">
            ・抽選の上、当選者へはご応募いただいたTwitterのアカウント宛てに当選のご連絡をいたします。<br />
            ・Nanaco【公式】Twitterアカウント「@nanacokume」から当選者のアカウントへDM（ダイレクトメッセージ）をお送りし、当選のご連絡とプレゼントに関するご案内をさせていただきます。<br />
            ・フォローの解除又はアカウントの凍結、削除、Twitter IDの変更等の理由によりDM（ダイレクトメッセージ）メッセージが送れない場合は当選を無効とさせていただきます。<br />
            ・応募者のフォロワー数が一定以上であることを当選条件とする場合がございます。<br />
            ・当選が無効となった場合、その後、プレゼントの送付依頼をいただいたとしても一切受け付けかねます。なお、無効となった当選が発生した場合、当選人数は上記記載の数に達しないことがあります。<br />
            ・景品表示法の規定により、当社で実施中の他のキャンペーンとの重複当選は出来ない場合がございます。<br />
            ・当選に関するお問い合わせにはお答えいたしかねます。
          </div>
        </div>
      </div>
      <div class="msg-list-box">
        <div class="msg-list-title">
          6. 個人情報について
        </div>
        <div class="msg-list">
          <div class="msg">
            ご提供いただいたお客様の個人情報は、当社にて厳重管理し、当選の通知、プレゼント送付および送付に伴う連絡に利用させていただきます。また、個人を特定しない形でのサービス向上のための統計データとして利用させていただきます。<br />
            個人情報をお客様の同意なしに第三者提供することは有りません。<br />
            ただし、法令に基づいて開示請求された場合はこの限りではありません。
          </div>
        </div>
      </div>
      <div class="msg-list-box">
        <div class="msg-list-title">
          7. 当キャンペーンに関するお問い合わせ先
        </div>
        <div class="msg-list">
          <div class="msg">
            お問い合わせは、Nanaco【公式】Twitterアカウント「@nanacokume」のDM（ダイレクトメッセージ）にて受け付けます。<br />
            <a href="https://twitter.com/nanacokume">https://twitter.com/nanacokume</a>
          </div>
        </div>
      </div>
    </div>
    <div
      class="footer"
      v-if="isPe === false"
    >
      <div class="bottom-area">
        <div class="link-us-box">
          <div class="link-us-fun">
            <div class="link-us-title">
              Message
            </div>
            <div class="link-us-msg">
              <Icon
                type="ios-call"
                class="icon"
              />4001-752-874
            </div>
            <div
              class="link-us-msg"
              @click="mailTo()"
            >
              <Icon
                type="md-mail"
                class="icon"
              />mail to us
            </div>
          </div>
          <div class="link-us-fun">
            <div class="link-us-title">
              Follow us
            </div>
            <div
              class="link-us-msg"
              style="background:#273978;"
              @click="toFaceBook()"
            >
              <Icon
                type="logo-facebook"
                class="icon"
              />Facebook
            </div>
            <div
              class="link-us-msg"
              style="background:rgb(38 178 209);"
              @click="toTwitter()"
            >
              <Icon
                type="logo-twitter"
                class="icon"
              />Twitter
            </div>
          </div>
        </div>
        <div class="link-us-qrcode">
          <div>
            <img :src="downloadImage.heyNanaco" />
            <img src="../images/home/heynanaco-qrcode.png" />
          </div>
          <div>
            <img :src="downloadImage.ios" />
            <img src="../images/home/apple-qrcode.png" />
          </div>
          <div>
            <img :src="downloadImage.android" />
            <img src="../images/home/google-qrcode.png" />
          </div>
          <div>
            <img :src="downloadImage.service" />
            <img src="../images/home/service-qrCode.png" />
          </div>
        </div>
        <!-- <div
          class="record-no"
          @click="linkTo()"
        >
          辽ICP备17016868号-3
        </div> -->
      </div>
    </div>
    <div
      class="to-home"
      @click="toHome()"
    >
      <Icon type="md-home" />
    </div>
  </div>
</template>
<script>
import banner from '../images/activity-page/banner.jpg'
import peBanner from '../images/activity-page/pe-banner.png'
import { downloadImage, aboutUs } from '../images/home/index'
import { logo } from '../images/menu/index'
export default {
  data () {
    return {
      banner,
      peBanner,
      logo,
      isPe: false,
      downloadImage,
      aboutUs
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) || /(Android)/i.test(navigator.userAgent)) {
        //alert(navigator.userAgent);
        this.isPe = true
      } else {
        // this.$router.push('/')
        this.isPe = false
      };
    },
    toHome () {
      if (this.isPe === true) {
        this.$router.push('/pe')
      } else {
        this.$router.push('/')
      }

    }
  },
}
</script>
<style scoped>
a {
  color: #222;
  text-decoration: underline;
}
.activity-box {
  width: 100%;
  height: 100%;
  overflow: auto;
  /* padding-bottom: 30px; */
}
.page1 {
  width: 80%;
  margin: 0 auto;
  max-width: 1500px;
  min-width: 1100px;
}
.banner {
  display: block;
  width: 100%;
  position: relative;
  z-index: 0;
}
.main-msg {
  width: 80%;
  height: auto;
  min-height: 200px;
  line-height: 40px;
  font-size: 15px;
  box-sizing: border-box;
  padding: 30px;
  margin: 0 auto;
  background: #fff;
  margin-top: -100px;
  box-shadow: 0px 0px 40px 0px rgba(211, 211, 211, 0.39);
  border-radius: 15px;
  position: relative;
  z-index: 1;
}
.link-url {
  width: 80%;
  margin: 0 auto;
  font-size: 20px;
  color: #222;
  margin-top: 40px;
}
.link-url a {
  color: #222;
  cursor: pointer;
  text-decoration: underline;
}
.msg-list-box {
  width: 80%;
  margin: 0 auto;
  margin-top: 40px;
}
.msg-list-title {
  position: relative;
  display: inline-block;
  padding: 0 5px;
  margin-bottom: 20px;
  height: 20px;
  font-size: 15px;
  line-height: 20px;
  color: #000;
}
.msg-list-title::before {
  content: '';
  position: absolute;
  width: 100%;
  background: #ffde00;
  height: 15px;
  z-index: -1;
  left: 0;
  top: 10px;
}
.msg {
  margin-bottom: 10px;
  line-height: 30px;
}
.to-home {
  position: fixed;
  right: 100px;
  bottom: 100px;
  text-align: center;
  font-size: 30px;
  width: 50px;
  height: 50px;
  line-height: 40px;
  box-shadow: 0px 0px 10px #999;
  border-radius: 25px;
  background: #fff;
  cursor: pointer;
}
.pe .page1 {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  padding-top: 3rem;
}
.pe .banner {
  width: 100%;
}
.pe .main-msg {
  font-size: 0.7rem;
  line-height: 1rem;
  margin-top: -4.5rem;
  padding: 0.5rem 1rem;
  width: 90%;
  border-radius: 10px;
  line-height: 1.3rem;
}
.pe .to-home {
  display: none;
}
.pe .link-url {
  font-size: 0.7rem;
  margin-top: 1rem;
}
.pe .msg-list-box {
  margin-top: 1rem;
  font-size: 0.7rem;
}
.pe .msg-list-title {
  font-size: 0.75rem;
  margin-bottom: 0.5rem;
}
.pe .msg-list-title::before {
  height: 0.6rem;
}
.pe .navbar {
  width: 100%;
  height: 3rem;
  padding-top: 1.5rem;
  background: #333333;
  font-weight: bold;
  color: #fff;
  font-size: 1rem;
  padding-bottom: 0.5rem;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 998;
}
.pe .title {
  text-align: center;
  line-height: 1rem;
  height: 1rem;
  box-sizing: border-box;
  padding: 0 1.5rem;
  transition: all 0.5s;
}
.pe .open-menu-icon {
  position: absolute;
  left: 1rem;
  top: 0.5rem;
  font-size: 1.4rem;
}
.pe .title img {
  height: 1.7rem;
  margin-top: -0.6rem;
}
.footer {
  width: 100%;
  background: #3a93d4;
  height: 300px;
  margin-top: 30px;
  min-width: 1100px;
}

.bottom-area {
  /* position: absolute;
  bottom: 0; */
  width: 1000px;
  /* top: 0;
  left: 0;
  right: 0; */
  margin: 0 auto;
  height: 100%;
  box-sizing: border-box;
  padding-top: 50px;
  padding-bottom: 50px;
  display: flex;
  z-index: 0;
}
.link-us-box {
  width: 400px;
  height: 100%;
  display: flex;
}
.link-us-fun {
  flex: 1;
  box-sizing: border-box;
  vertical-align: top;
}
.link-us-title {
  font-size: 15px;
  font-weight: bold;
  color: #fff;
}
.link-us-msg {
  background: #fff;
  border-radius: 5px;
  width: 180px;
  padding: 7px;
  margin-top: 30px;
  vertical-align: top;
  font-size: 12px;
  cursor: pointer;
}
.link-us-msg .icon {
  font-size: 20px;
  margin-right: 5px;
  /* margin-top:px; */
  vertical-align: top;
}
.link-us-qrcode {
  width: 500px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding-left: 0px;
}
.link-us-qrcode div {
  width: 120px;
  margin: 0 5px;
}
.link-us-qrcode div img:nth-child(1) {
  display: block;
  width: 100%;
}
.link-us-qrcode div img:nth-child(2) {
  width: 120px;
  height: 120px;
  border: solid 5px #222;
  margin-top: 20px;
}
.record-no {
  width: 300px;
  text-align: center;
  bottom: 0;
  position: absolute;
  height: 49px;
  left: 0;
  right: 0;
  margin: auto;
  color: #707691;
  font-size: 12px;
}
.link-us-box .link-us-fun:nth-child(2) .link-us-msg {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/activity-page/index.vue